import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Link } from '@cian/link-component';
import * as React from 'react';
import { EActiveView } from '../../types/view';
import { EEventType } from '../../types/events';
import { ESentEmailType } from '../../types/sentEmail';
import { IconEmail } from './assets/email';
import * as styles from './styles.css';
import { trackRegistrationDonePopupClose } from '../../utils/tracking';
export var EmailSentView = /*#__PURE__*/function (_React$Component) {
  _inherits(EmailSentView, _React$Component);

  var _super = _createSuper(EmailSentView);

  function EmailSentView() {
    var _this;

    _classCallCheck(this, EmailSentView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleGotItClick", function (event) {
      event.preventDefault();
      var _this$props = _this.props,
          viewData = _this$props.viewData,
          changeView = _this$props.changeView,
          reset = _this$props.reset,
          changeLogin = _this$props.changeLogin,
          emit = _this$props.emit;

      switch (viewData.type) {
        case ESentEmailType.Restore:
          if (viewData.nextView) {
            changeView(viewData.nextView);
            break;
          }

          reset();
          changeLogin(viewData.email);
          changeView(EActiveView.AuthenticationRegistration);
          emit(EEventType.EmailSentClosed, {
            type: ESentEmailType.Restore
          });
          break;

        case ESentEmailType.Registration:
          trackRegistrationDonePopupClose();
          emit(EEventType.EmailSentClosed, {
            type: ESentEmailType.Registration
          });
          break;
      }
    });

    return _this;
  }

  _createClass(EmailSentView, [{
    key: "render",
    value: function render() {
      var viewData = this.props.viewData;
      var content;

      switch (viewData.type) {
        case ESentEmailType.Registration:
          content = 'Отправили письмо с подтверждением на электронную почту';
          break;

        case ESentEmailType.Restore:
          content = /*#__PURE__*/React.createElement(React.Fragment, null, "\u041D\u0430 ", /*#__PURE__*/React.createElement("strong", null, viewData.email), " \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043F\u0438\u0441\u044C\u043C\u043E c \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0435\u0439 \u0434\u043B\u044F \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u0430\u0440\u043E\u043B\u044F");
          break;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: styles['container']
      }, /*#__PURE__*/React.createElement("div", {
        className: styles['icon']
      }, /*#__PURE__*/React.createElement(IconEmail, null)), /*#__PURE__*/React.createElement("p", {
        className: styles['description']
      }, content), /*#__PURE__*/React.createElement(Link, {
        href: "#",
        className: styles['finish'],
        onClick: this.handleGotItClick,
        title: "\u042F\u0441\u043D\u043E"
      }, "\u041F\u043E\u043D\u044F\u0442\u043D\u043E"));
    }
  }]);

  return EmailSentView;
}(React.Component);